module.exports = __webpack_public_path__ + "static/media/success_tick.b10b1574.jpg";